import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';

type MessageSentModalProps = CommonTemplateProps & {
  readonly onClose?: () => void;
};

export const MessageSentModal = ({
  closeModal,
  isOpen,
  onClose,
}: MessageSentModalProps) => {
  const handleClose = () => {
    closeModal();
    onClose?.();
  };

  return (
    <ModalTemplateWrapper
      ariaLabel="message-sent-modal"
      closeIconColor="black"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleClose,
          isLoading: false,
          label: 'Thanks',
          variant: 'V2Primary',
        },
      }}
      desktopModalSize="md"
      headerText="Message Sent"
      isFullscreenOnMobile
      isOpen={isOpen}
      lockPointerEvents
      onClose={handleClose}
      preventAutoFocus
      preventFocusContain
      subheaderText="Your inquiry was sent successfully! Our team keeps tabs on all
      incoming inquiries to ensure that they're high quality—
      we'll reach out if there are any issues. Best of luck!"
    />
  );
};
